import type { DerivedTrialUpgradeNudgeState } from './types';

/** Countdown label appears at or below this many calendar days remaining. */
export const TRIAL_UPGRADE_NUDGE_COUNTDOWN_THRESHOLD_DAYS = 7;

/** Nudge moves from sidebar to the session header at or below this threshold. */
export const TRIAL_UPGRADE_NUDGE_ESCALATION_THRESHOLD_DAYS = 2;

/**
 * Maps trial days remaining to nudge placement and visual state per
 * Figma "Final Decision" thresholds.
 */
export function deriveTrialUpgradeNudgeState(
  daysRemaining: number
): DerivedTrialUpgradeNudgeState {
  if (daysRemaining <= TRIAL_UPGRADE_NUDGE_ESCALATION_THRESHOLD_DAYS) {
    return { placement: 'top_right', state: 'countdown' };
  }
  if (daysRemaining <= TRIAL_UPGRADE_NUDGE_COUNTDOWN_THRESHOLD_DAYS) {
    return { placement: 'sidebar', state: 'countdown' };
  }
  return { placement: 'sidebar', state: 'icon_only' };
}
